import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    margin: 0,
    paddingTop: '1rem',
    paddingBottom: '1rem',
    fontSize: '2rem',
    fontWeight: 300,
    lineHeight: 1.1,
    color: '#fff',
    textAlign: 'center',
    textTransform: 'none',
  },
  description: {
    margin: 0,
    padding: '2rem',
    fontSize: '1rem',
    lineHeight: 2,
    color: '#fff',
    textAlign: 'center',
  },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 40,
  },
  em: {
    marginLeft: 20,
    marginRight: 20,
    fontSize: 14,
    color: '#fff',
  },
  button: {
    paddingLeft: 24,
    paddingRight: 24,
    fontSize: 15,
    color: '#fff',
    background: '#347AC4',
    '&:hover': {
      backgroundColor: theme.custom.mainColor,
      borderColor: theme.custom.mainColor,
      color: '#fff',
    },
    '&:focus': {
      outline: 0,
    },
  },
  passwordResetLink: {
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    color: '#fff',
    textDecoration: 'underline',
  },
}));
